<span *ngFor="let paragraph of paragraphs">
  <ion-skeleton-text *ngFor="let line of lines" class="skeleton-line" [ngClass]="sizeClass" animated></ion-skeleton-text>
  <ion-skeleton-text class="skeleton-line final-line" [ngClass]="lastLineSizeClass" animated></ion-skeleton-text>
</span>
